// @flow
/* eslint-disable import/prefer-default-export */
// $FlowFixMe
import type { UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { QUERIES } from "@/enums/queries";

import { deleteGoogleSheetsSettings } from "./services/mutateGoogleSheetsSettings";
import { invalidateLoadGoogleSheetsSettings } from "./useLoadGoogleSheetsSettings";

export type Props = {
  deleteGoogleSheetsSetting: (id: string) => Promise<void>,
  isLoading: boolean,
} & UseMutationResult<void, Error>;

export const useDeleteGoogleSheetsSettings = (options: any = {}): Props => {
  const mutation = useMutation({
    mutationKey: [QUERIES.GOOGLE_SHEETS_SETTINGS.DELETE],
    mutationFn: async (id: string) => await deleteGoogleSheetsSettings(id),
    onSuccess: () => {
      invalidateLoadGoogleSheetsSettings();
    },
    ...options,
  });

  const deleteGoogleSheetsSettingReq = async (id: string) => {
    return mutation.mutateAsync(id);
  };

  return {
    deleteGoogleSheetsSetting: deleteGoogleSheetsSettingReq,
    ...mutation,
  };
};
